import { render, staticRenderFns } from "./banner-nav.vue?vue&type=template&id=5f986f9a&scoped=true&"
import script from "./banner-nav.vue?vue&type=script&lang=js&"
export * from "./banner-nav.vue?vue&type=script&lang=js&"
import style0 from "./banner-nav.vue?vue&type=style&index=0&id=5f986f9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f986f9a",
  null
  
)

export default component.exports